export function DetailPage() {
  return (
    <>
      <h2>Detail Page</h2>
    </>
  );
}
